export const restaurantImageOrDefault = (
  url: string | undefined | null,
  fileExtension: string = 'jpeg'
) => (url ? url : '/assets_rd/sk-header-placeholderimage.' + fileExtension);
